
import { defineComponent } from 'vue'
import { format } from 'date-fns'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrDatepicker from '@nextrequestco/components/src/components/NrDatePicker/nr-datepicker.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import { mapActions } from 'vuex'

export default defineComponent({
  name: 'request-duedate',
  components: {
    NrIconButton,
    NrFormInput,
    NrIcon,
    NrTooltip,
    NrModal,
    NrDatepicker
  },
  props: {
    prettyId: { type: String },
    date: { type: String }
  },
  data() {
    return {
      showModal: false,
      updating: false,
      newDate: null,
      description: ''
    }
  },
  computed: {
    computedDate(): Date | null {
      if (Date.parse(this.date)) {
        // @ts-ignore: NEX-9140
        return format(new Date(this.date), 'MM/dd/yyyy')
      }
      return null
    },
    unselectableDates(): Date[] {
      if (this.computedDate) {
        return [this.computedDate]
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions('request_show', ['updateDuedate', 'fetchTimeline']),

    handleDateInput(date: Date) {
      this.newDate = date
    },

    async handleSaveData() {
      if (!this.newDate) return

      this.updating = true
      try {
        await this.updateDuedate({
          prettyId: this.prettyId,
          date: format(new Date(this.newDate), 'MM/dd/yyyy'),
          description: this.description
        })
        this.fetchTimeline({ pretty_id: this.prettyId })
        this.$toasted.success('Successfully updated request due date')
      } catch (error) {
        this.$toasted.error(
          'Request failed to update new due date. Please refresh the page and try again.'
        )
      }

      this.updating = false
      this.toggleModal(false)
    },

    toggleModal(state?: boolean) {
      this.showModal = state ?? !this.showModal
    }
  }
})
